import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { CodeEmbed } from './codeEmbed'
import { CodeEmbedServer } from './codeEmbedServer'
import { LifeCycle } from '@wix/thunderbolt-symbols'

export { config } from './configs'

export const site: ContainerModuleLoader = (bind) => {
	if (process.env.browser) {
		bind(LifeCycle.AppWillLoadPageHandler).to(CodeEmbed)
	} else {
		bind(LifeCycle.AppWillLoadPageHandler).to(CodeEmbedServer)
	}
}
